/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScanAvailableModel } from '../../models/scan-available-model';

export interface ScanAvailableProfileIdGet$Params {

/**
 * The profile ID
 */
  profileId: string;
}

export function scanAvailableProfileIdGet(http: HttpClient, rootUrl: string, params: ScanAvailableProfileIdGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<ScanAvailableModel>> {
  const rb = new RequestBuilder(rootUrl, scanAvailableProfileIdGet.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<ScanAvailableModel>;
    })
  );
}

scanAvailableProfileIdGet.PATH = '/Scan/Available/{profileId}';
